import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Product, ProductFilter, ProductResponse, ProductCategory } from '../../types/product.types';

export const productApi = createApi({
  reducerPath: 'productApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/products',
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as any).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Product', 'Category'],
  endpoints: (builder) => ({
    getProducts: builder.query<ProductResponse, ProductFilter>({
      query: (filter) => ({
        url: '',
        params: filter,
      }),
      providesTags: ['Product'],
    }),
    getProductById: builder.query<Product, string>({
      query: (id) => `/${id}`,
      providesTags: (result, error, id) => [{ type: 'Product', id }],
    }),
    getCategories: builder.query<ProductCategory[], void>({
      query: () => '/categories',
      providesTags: ['Category'],
    }),
    getFeaturedProducts: builder.query<Product[], void>({
      query: () => '/featured',
      providesTags: ['Product'],
    }),
    searchProducts: builder.query<ProductResponse, string>({
      query: (query) => ({
        url: '/search',
        params: { q: query },
      }),
      providesTags: ['Product'],
    }),
  }),
});

export const {
  useGetProductsQuery,
  useGetProductByIdQuery,
  useGetCategoriesQuery,
  useGetFeaturedProductsQuery,
  useSearchProductsQuery,
} = productApi;
